<section class="policy-content delivery-content" appReveal>
  <div class="policy-content__inner">

    <!-- Intro (no heading) -->
    <div class="policy-content__section" appReveal="100">
      <p class="policy-content__paragraph" i18n="@@delivery.intro.p1">由於我們所有產品確保新鮮，都為即日制作。故客人需要預早 4 天下單及需要於 24 小時內入數，所有訂單均須確認全數付清後才開始製作。</p>
      <p class="policy-content__paragraph" i18n="@@delivery.intro.p2">每日下午 4 時或之後的訂單，將於下一個工作天處理。滿 <span class="policy-content__label">$1400</span> 免費送貨（除不配送地區外）。</p>
      <p class="policy-content__paragraph" i18n="@@delivery.intro.p3">訂單一經確定，不設退款。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- 運費 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@delivery.fee.heading">運費</h2>
      <div class="policy-content__callout">
        <p class="policy-content__callout-line" i18n="@@delivery.fee.callout">
          <span class="policy-content__label">$1400 以下：</span>除不配送地區外，所有地點運費劃一為 <span class="policy-content__highlight">港幣 $150</span>
        </p>
      </div>
      <p class="policy-content__paragraph" i18n="@@delivery.fee.excluded">
        <span class="policy-content__label">不配送地區：</span>石崗、錦繡花園、流浮山、沙頭角、落馬洲、羅湖、機場、大嶼山、愉景灣、梅窩、貝澳、長沙、塘福、長洲、南丫島、坪洲
      </p>
    </div>

    <hr class="policy-content__divider">

    <!-- 產品品質及簽收 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@delivery.quality.heading">產品品質及簽收</h2>
      <p class="policy-content__paragraph" i18n="@@delivery.quality.p1">所有於網上訂購出售的商品均為新鮮食品，我們會於運送前確保所有訂單的品質良好，而顧客有責任於訂單送遞時檢查清楚。</p>
      <p class="policy-content__paragraph" i18n="@@delivery.quality.p2">如訂單已簽收，即代表顧客對所有購買的產品感到滿意，在此情況下往後提出的退款申請，我們恕不退換。如因為運送過程而導致訂單的品質出現損壞，顧客可以即時退還產品，我們會稍後安排更換。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- 不接受退換的情況 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@delivery.returnExclusions.heading">不接受退換的情況</h2>
      <ul class="policy-content__list">
        <li class="policy-content__list-item" i18n="@@delivery.returnExclusions.item1">所有已檢查並簽收的訂單</li>
        <li class="policy-content__list-item" i18n="@@delivery.returnExclusions.item2">所有特惠促銷或贈品</li>
        <li class="policy-content__list-item" i18n="@@delivery.returnExclusions.item3">所有已食用的產品</li>
        <li class="policy-content__list-item" i18n="@@delivery.returnExclusions.item4">所有因逾時未能自取，已於此期間品質出現變異的商品</li>
      </ul>
    </div>

    <hr class="policy-content__divider">

    <!-- 退換程序 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@delivery.returnProcess.heading">退換程序</h2>
      <p class="policy-content__paragraph" i18n="@@delivery.returnProcess.intro">
        如需退換，請致電 <span class="policy-content__label">26901853</span> 或電郵 <span class="policy-content__highlight">order@chouxcreme.com.hk</span> 給我們，並請提供以下資料：
      </p>
      <ul class="policy-content__list">
        <li class="policy-content__list-item" i18n="@@delivery.returnProcess.item1">閣下的訂單編號</li>
        <li class="policy-content__list-item" i18n="@@delivery.returnProcess.item2">下單日期</li>
        <li class="policy-content__list-item" i18n="@@delivery.returnProcess.item3">貨品送遞後的情況（請提供相片）</li>
      </ul>
    </div>

    <hr class="policy-content__divider">

    <!-- 惡劣天氣安排 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@delivery.weather.heading">惡劣天氣安排</h2>
      <p class="policy-content__paragraph" i18n="@@delivery.weather.p1">當香港天文台懸掛 8 號或以上颱風信號發出時，將不設送貨服務。在此情況 J-Sweets Co.,Ltd 接受顧客改期，顧客可選擇 14 日內再次提取。颱風當日我們亦會致電聯絡顧客，以作跟進有關改期安排。</p>
      <p class="policy-content__paragraph" i18n="@@delivery.weather.p2">而黑色暴雨警告信號發出時，將暫停送貨服務。信號取消後，我們將再次聯絡顧客及再次安排送貨。</p>
      <div class="delivery-content__alert">
        <p class="delivery-content__alert-line" i18n="@@delivery.weather.alert">**所有因天文台懸掛 8 號或以上颱風信號或黑色暴雨警告信號發出而影響送貨服務，顧客可選擇 14 日內再次提取，均不設退款。**</p>
      </div>
    </div>

    <hr class="policy-content__divider">

    <!-- Dispute (no heading) -->
    <div class="policy-content__section" appReveal="100">
      <p class="policy-content__paragraph" i18n="@@delivery.dispute">如有任何爭議，J-Sweets Co.,Ltd 保留最終決定權。</p>
    </div>

  </div>
</section>
